module.exports = __webpack_public_path__ + "img/Header.4c5e0918.jpg";